import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function AccessToggle({ u, onChanged }) {
  const [confirm, setConfirm] = useState(false);
  const active = u.active !== false;
  const save = async (value) => {
    try { await api.put(`/users/${u.id}/access`, { active: value }); toast.success(value ? `${u.name} can sign in again` : `${u.name}'s login is switched off`); setConfirm(false); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <label className="mt-3 flex items-center justify-between rounded-lg border border-[#E7E2D6] px-3 py-2 text-sm">
        <span className={active ? "text-[#0F382C]" : "font-semibold text-rose-700"} data-testid={`user-access-label-${u.id}`}>{active ? "Login on" : "Login switched off"}</span>
        <Switch checked={active} onCheckedChange={(v) => (v ? save(true) : setConfirm(true))} data-testid={`user-access-switch-${u.id}`} />
      </label>
      <Dialog open={confirm} onOpenChange={setConfirm}>
        <DialogContent className="max-w-sm" data-testid={`user-access-dialog-${u.id}`}>
          <DialogHeader><DialogTitle className="font-display">Switch off {u.name}'s login?</DialogTitle>
            <DialogDescription>They are signed out straight away and can't sign in again. Their deliveries, leads, payments and history stay. They also stop getting new leads, routes and WhatsApp lists. You can switch it back on any time.</DialogDescription></DialogHeader>
          <DialogFooter><Button variant="outline" onClick={() => setConfirm(false)} data-testid={`user-access-cancel-${u.id}`}>Cancel</Button>
            <Button className="bg-rose-600 hover:bg-rose-700" onClick={() => save(false)} data-testid={`user-access-confirm-${u.id}`}>Switch off</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
